import { getDeployEnv } from '@fe/config'
import { getUrl } from '@fe/utils'

// @ts-ignore
export const DEPLOY_ENV = getDeployEnv((getUrl(location.href, 'deploy_env') as any) || process.env.DEPLOY_ENV)

export const NODE_ENV = process.env.NODE_ENV
export const DEBUG = process.env.DEBUG
export const PORT = process.env.PORT
export const MOCK_PORT = process.env.MOCK_PORT
export const MOCK_HOST = process.env.MOCK_HOST

export const APP_NAME = process.env.APP_NAME
export const SPA = process.env.SPA

export const USER_DEVICE = `userAgent`

export const USER_TAG = 'userTag'

export const USER_ACCOUNT_INFO = `userAccountInfo`

export const DEPLOY_ENV_PURE = DEPLOY_ENV === 'prod' ? '' : DEPLOY_ENV

export const DEPLOY_ENV_WITH_PREFIX = DEPLOY_ENV === 'prod' ? '' : '-' + DEPLOY_ENV

export const DOMAIN_CDN = `https://evt.cdfsunrise.com` // 默认为当前业务域名，存储于OSS

export const H5_DOMAIN_NAME = DEPLOY_ENV === 'prod' ? `https://h5.cdfsunrise.com` : `https://h5-${DEPLOY_ENV}.cdfsunrise.com`

console.log('H5_DOMAIN_NAME', H5_DOMAIN_NAME)

export const SENSORS_SERVER_URL = process.env.DEPLOY_ENV === 'prod' && process.env.NODE_ENV === 'production' ? `https://shence-prod.cdfsunrise.com:8106/sa?project=production` : 'https://shence-prod.cdfsunrise.com:8106/sa?project=default'

export const PACKAGE = 'com.cdfsunrise.cdflehu'

export const ENVS = ['dev', 'qa', 'pre', 'alpha', 'demo', 'prod']
